<template lang="pug"></template>

<script>
export default {
    name: 'BotaoRelatorioRastreabilidade',
    componentOptions: {
        title: 'Relatorio de Rastreabilidade',
        actions: [
            [
                {
                    name: 'Relatório de Rastreabilidade',
                    iconClass: 'lyra-icon lyra-relatorio-rastreabilidade',
                    showView: false,
                    action: 'abrirRelatorioRastreabilidade',
                    route: 'RelatorioRastreabilidade'
                }
            ]
        ]
    },

    methods: {
        abrirRelatorioRastreabilidade() {
            if (this.$route.name !== 'RelatorioRastreabilidade') {
                this.$router.push({ name: 'RelatorioRastreabilidade' });
            } else {
                this.$router.go();
            }
        }
    }
};
</script>
